<script>
import { mapActions } from "vuex";
import AppInput from "../ui/AppInput.vue";
import AppSelect from "../ui/AppSelect.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  components: { AppInput, AppSelect },

  data: (vm) => ({
    object: {
      id: null,
      firstName: null,
      lastName: null,
      middleName: null,
      phone: null,
      password: null,
      role: null,
    },

    confirmPassword: null,
    model: true,
    errors: {},

    roles: [
      { id: "ADMIN_SUPER", name: vm.$t("ADMIN_SUPER") },
      { id: "ADMIN_VERIFIER", name: vm.$t("Admin verifier") },
      { id: "ADMIN_OBSERVER", name: vm.$t("Admin observer") },
      { id: "ACCOUNTER", name: vm.$t("Accounter") },
      { id: "ACCOUNTER_HELPER", name: vm.$t("Accounter helper") },
      { id: "QABUL_QILUVCHI", name: vm.$t("Qabul qiluvchi") },
      { id: "CONTRACTER", name: vm.$t("CONTRACTER") },
      { id: "BITRIX_OBSERVER", name: vm.$t("Bitrix observer") },
      { id: "BITRIX_MANAGER", name: vm.$t("Bitrix manager") },
    ],
  }),

  watch: {
    model() {
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    },
  },

  created() {
    if (this.data.id) {
      this.object = JSON.parse(JSON.stringify(this.data));
    }
  },

  methods: {
    ...mapActions("admin-member", ["ADD_MEMBER"]),

    validate() {
      this.errors = {};

      if (!this.object.firstName) this.errors.firstName = this.$t("Required");
      if (!this.object.lastName) this.errors.lastName = this.$t("Required");
      if (!this.object.phone) this.errors.phone = this.$t("Required");

      if (!this.object.id) {
        if (!this.object.password) this.errors.password = this.$t("Required");
        if (!this.confirmPassword) {
          this.errors.confirmPassword = this.$t("Required");
        } else if (this.confirmPassword !== this.object.password) {
          this.errors.confirmPassword = this.$t("The password confirmation does not match.");
        }
      }

      if (!this.object.role) this.errors.role = this.$t("Required");

      return Object.keys(this.errors).length === 0;
    },

    onSend() {
      if (this.validate()) {
        this.ADD_MEMBER(this.object).then((status) => {
          if (status != null) {
            this.$emit("refresh");
            this.model = false;
          }
        });
      }
    },
  },
};
</script>

<template>
  <v-dialog v-model="model" max-width="520" content-class="member-dlg">
    <div class="m-modal">
      <div class="m-header">
        <h3>{{ $t('Admins') }}</h3>
        <button class="m-close" @click="model = false" type="button">
          <v-icon size="20">mdi-close</v-icon>
        </button>
      </div>

      <div class="m-body">
        <div class="m-field">
          <label class="m-label">{{ $t('First name') }}</label>
          <app-input v-model="object.firstName" :placeholder="$t('First name')" dense />
          <div v-if="errors.firstName" class="m-error">{{ errors.firstName }}</div>
        </div>

        <div class="m-field">
          <label class="m-label">{{ $t('Last name') }}</label>
          <app-input v-model="object.lastName" :placeholder="$t('Last name')" dense />
          <div v-if="errors.lastName" class="m-error">{{ errors.lastName }}</div>
        </div>

        <div class="m-field">
          <label class="m-label">{{ $t('Middle name') }}</label>
          <app-input v-model="object.middleName" :placeholder="$t('Middle name')" dense />
        </div>

        <div class="m-field">
          <label class="m-label">{{ $t('Phone number') }}</label>
          <app-input
            v-model="object.phone"
            :placeholder="$t('Phone number')"
            :mask="$masks.number2"
            dense
          />
          <div v-if="errors.phone" class="m-error">{{ errors.phone }}</div>
        </div>

        <template v-if="!object.id">
          <div class="m-field">
            <label class="m-label">{{ $t('Password') }}</label>
            <app-input v-model="object.password" :placeholder="$t('Password')" type="password" dense />
            <div v-if="errors.password" class="m-error">{{ errors.password }}</div>
          </div>

          <div class="m-field">
            <label class="m-label">{{ $t('Confirm password') }}</label>
            <app-input v-model="confirmPassword" :placeholder="$t('Confirm password')" type="password" dense />
            <div v-if="errors.confirmPassword" class="m-error">{{ errors.confirmPassword }}</div>
          </div>
        </template>

        <div class="m-field">
          <label class="m-label">{{ $t('Role') }}</label>
          <app-select
            v-model="object.role"
            :items="roles"
            item-text="name"
            item-value="id"
            :placeholder="$t('Select role')"
            dense
            hide-details
          />
          <div v-if="errors.role" class="m-error">{{ errors.role }}</div>
        </div>
      </div>

      <div class="m-footer">
        <button class="m-btn-cancel" @click="model = false">{{ $t('Cancel') }}</button>
        <button class="m-btn-save" @click="onSend">{{ $t('Save') }}</button>
      </div>
    </div>
  </v-dialog>
</template>

<style lang="scss">
.member-dlg.v-dialog {
  max-height: none !important;
  overflow: visible !important;
  margin: 24px auto !important;
}
.v-dialog__content:has(.member-dlg) {
  align-items: flex-start !important;
}
</style>

<style lang="scss" scoped>
.m-modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12);
}

.m-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 12px;
}
.m-header h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: #111318;
}

.m-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: none;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.15s;
}
.m-close:hover {
  border-color: #d1d5db;
  background: #f9fafb;
  color: #111318;
}

.m-body {
  padding: 8px 24px 16px;
}

.m-field {
  margin-bottom: 16px;
}
.m-field:last-child {
  margin-bottom: 0;
}

.m-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6b7280;
  margin-bottom: 6px;
}

.m-error {
  font-size: 12px;
  color: #ff5252;
  margin-top: 4px;
  padding-left: 2px;
}

.m-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 24px 20px;
}

.m-btn-cancel {
  padding: 8px 20px;
  border-radius: 10px;
  border: 1px dashed #d1d5db;
  background: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.m-btn-cancel:hover {
  border-color: #9ca3af;
  color: #111318;
}

.m-btn-save {
  padding: 8px 24px;
  border-radius: 10px;
  border: none;
  background: #00274c;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.m-btn-save:hover {
  background: #001d3a;
}

/* ── Dark mode ── */
.theme--dark .m-modal {
  background: #1a1b23;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);
}
.theme--dark .m-header h3 {
  color: #e4e5eb;
}
.theme--dark .m-close {
  border-color: #2a2c3a;
  color: #8b8d9e;
}
.theme--dark .m-close:hover {
  border-color: #3a3c4a;
  background: #22232e;
  color: #e4e5eb;
}
.theme--dark .m-label {
  color: #8b8d9e;
}
.theme--dark .m-btn-cancel {
  border-color: #2a2c3a;
  color: #8b8d9e;
}
.theme--dark .m-btn-cancel:hover {
  border-color: #3a3c4a;
  color: #e4e5eb;
}
.theme--dark .m-btn-save {
  background: #ffd451;
  color: #111318;
}
.theme--dark .m-btn-save:hover {
  background: #f5c542;
}
</style>
